import Service from "../AuthService";

const Direction = {
    getAllDirections() {
        return Service.get(`directions`);
    }
};

export default Direction;
